export default __webpack_public_path__ + "static/media/group-6381.9edb3db5.svg";